import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";

export default function About() {
    const { t } = useLang();
    return (
        <section id="about" className="relative py-20 sm:py-24 md:py-32" data-testid="sau-about">
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
                    <div className="lg:col-span-5">
                        <SectionHeading eyebrow={t.about.eyebrow} title={t.about.title} />
                    </div>
                    <div className="lg:col-span-7">
                        <p className="sau-reveal text-base sm:text-lg md:text-xl text-[color:var(--sau-text-2)] leading-relaxed">
                            {t.about.body}
                        </p>
                        <div className="sau-reveal mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                            {t.about.pillars.map((p, i) => (
                                <div key={`pillar-${i}`} className="sau-card rounded-2xl p-5">
                                    <div className="text-[10px] uppercase tracking-[0.28em] text-[color:var(--sau-accent)]">
                                        {p.label}
                                    </div>
                                    <div className="mt-3 text-sm text-[color:var(--sau-text-2)] leading-relaxed">
                                        {p.detail}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
